import { uniqBy } from "lodash";
import { useCallback } from "react";

export default function useCountAcceptancesByCustomer(acceptances: Jury.Resources.Acceptance[] | undefined) {
    return useCallback((id: number) => {
        if (!acceptances)
            return 0
        
        const awards = acceptances.filter(acceptance => {
            return acceptance.photo.user.id === id && acceptance.award
        })

        return {
            awards: awards.length,
            sections: uniqBy(awards, award => award.section.id).length
        }
    }, [acceptances])
}